module.exports = __webpack_public_path__ + "img/dpd.d1bc6aa9.png";